import { callAPI } from "../../config/AxiosTemplate";
import { API } from "../../constants/APIConstants";

export const getCollectionApprovalQueueAction = (requestData, callback) => {
  let requestString = "";
  if (requestData && requestData.minimartId) {
    requestString = "?minimartId=" + requestData.minimartId;
  }
  callAPI(
    "getCollectionApprovalQueue",
    API.collectionApprovalQueue.concat(requestString),
    "GET",
    {},
    (apiResponse) => {
      callback(apiResponse);
    }
  );
};

export const getCollectionApprovalHistoryAction = (requestData, callback) => {
  callAPI(
    "getCollectionApprovalHistory",
    API.collectionApprovalHistory.concat(requestData.minimartId),
    "GET",
    {},
    (apiResponse) => {
      callback(apiResponse);
    }
  );
};

export const approveCollectionPaymentAction = (requestData, callback) => {
  callAPI(
    "approveCollectionPayment",
    API.approveCollectionPayment.concat(requestData.approvalId, "/approve"),
    "POST",
    {
      waiveLateFee: requestData.waiveLateFee,
      note: requestData.note,
      // only needed when the collector sent no bank, left out of the body otherwise
      bankId: requestData.bankId,
    },
    (apiResponse) => {
      callback(apiResponse);
    }
  );
};

export const rejectCollectionPaymentAction = (requestData, callback) => {
  callAPI(
    "rejectCollectionPayment",
    API.rejectCollectionPayment.concat(requestData.approvalId, "/reject"),
    "POST",
    { note: requestData.note },
    (apiResponse) => {
      callback(apiResponse);
    }
  );
};

export const viewCollectionEvidenceAction = (requestData, callback) => {
  callAPI(
    "viewCollectionEvidence",
    API.viewUploadedTranferReceipt.concat(requestData.evidenceId),
    "GET",
    {},
    (apiResponse) => {
      callback(apiResponse);
    }
  );
};

export const getCollectionBanksAction = (callback) => {
  callAPI(
    "getCollectionBanks",
    API.getCollectionBanks,
    "GET",
    {},
    (apiResponse) => {
      callback(apiResponse);
    }
  );
};

// filtered, paged list of payment requests of any status
export const searchCollectionApprovalAction = (requestData, callback) => {
  callAPI(
    "searchCollectionApproval",
    API.collectionApprovalSearch,
    "POST",
    requestData,
    (apiResponse) => {
      callback(apiResponse);
    }
  );
};

// PDF or CSV of every request matching the filters, not just the page on screen
export const downloadCollectionApprovalAction = (
  fileType,
  requestData,
  callback
) => {
  callAPI(
    "downloadCollectionApproval",
    API.collectionApprovalDownload.concat(fileType),
    "POST",
    requestData,
    (apiResponse) => {
      callback(apiResponse);
    },
    true
  );
};
